import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import {
  AppStateActions,
  ConfigService,
  FetchCurrentUserGroups,
  FetchCurrentUserProfile,
  OrgConfiguration,
  UserPreferencesActions,
  UserPreferencesState,
  UserState,
} from '@osos/shared/legacy-core';
import { ComponentBase } from '@osos/shared/utility';
import { switchMap, take, takeUntil, withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss'],
  standalone: false,
})
export class WelcomePageComponent extends ComponentBase implements OnInit {
  currentUser: any;

  get orgConfig(): OrgConfiguration {
    return this.config.orgConfig;
  }

  constructor(
    private store: Store,
    private router: Router,
    private config: ConfigService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.store
      .dispatch(new FetchCurrentUserProfile())
      .pipe(
        switchMap(() => this.store.select(UserState.currentUser)),
        takeUntil(this.destroy$),
      )
      .subscribe((response) => {
        this.currentUser = response?.value?.basic_info;
      });
    this.store.dispatch(new FetchCurrentUserGroups());
  }

  onStartUsingClicked(): void {
    // Update the state:
    this.store
      .dispatch(new UserPreferencesActions.SetIsFirstLogin(false))
      .pipe(
        withLatestFrom(
          this.store.selectOnce(UserPreferencesState.tourSupported),
          this.store.selectOnce(UserPreferencesState.tourEnabled),
        ),
        take(1),
      )
      .subscribe(([tourSupported, tourEnabled]: any) => {
        if (tourSupported && tourEnabled) {
          this.store.dispatch(new UserPreferencesActions.StartTours());
          return;
        }

        // Redirect to HOME page:
        this.router.navigate(['home'], {
          replaceUrl: true,
        });

        // Load the current user related data:
        this.store.dispatch(new AppStateActions.LoadUserRelatedData());
      });
  }
}
